import { render, staticRenderFns } from "./order-food.vue?vue&type=template&id=1d0eecba&scoped=true"
import script from "./order-food.vue?vue&type=script&lang=js"
export * from "./order-food.vue?vue&type=script&lang=js"
import style0 from "./order-food.vue?vue&type=style&index=0&id=1d0eecba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0eecba",
  null
  
)

export default component.exports